$(document).ready(function() {
	
	// autocomplete form functionality
	if ($('#autocomplete-form').length > 0) {
		autocomplete();
		initialSearchForm();
	}
	
	// frequently asked questions
	$('.ace-faq-question').on('click', function() {
		$(this).parent().toggleClass('ace-faq-active');
	});
	
	// contact form 
	$('#ace-contact-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('.form-field'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'name': {
				required: true,
				minlength: 2
			},
			'email-address': {
				required: true,
				email: true
			},
			'phone-number': {
				phoneUS: true
			},
			'message': {
				required: true,
				minlength: 2
			}
		},
		messages: {
			'name': {
				required: 'Please enter your name.',
				minlength: 'Your name must be at least 2 characters long.'
			},
			'email-address': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			},
			'phone-number': {
				phoneUS: 'Please enter a valid telephone number.'
			},
			'message': {
				required: 'Please explain how we can help you.',
				minlength: 'Your message must be at least 2 characters long.'
			}
		},
		submitHandler: function(form) {
			$('.button-spinner', form).prop('disabled', true);
			
			var name = $('#name', form).val();
			var email = $('#email-address', form).val();
			var phone = $('#phone-number', form).val();
			var message = $('#message', form).val();
			var nonce = $('#ace-contact-form-nonce', form).val();
			
			$.ajax({
				type: 'post',
				url: '/wp-admin/admin-ajax.php',
				data: {
					action: 'ace_contact_form',
					name: name,
					email: email,
					phone: phone,
					message: message,
					nonce: nonce
				},
				success: function(results) {
					var results = JSON.parse(results);
					console.log(results);
					if (results.status === 'success') {
						$('.form-card-message', form).removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);
					} else if (results.status === 'error') {
						$('.form-card-message', form).removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
					} else {
						$('.form-card-message', form).removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something went wrong. Try again?');
					}
					$('.button-spinner', form).prop('disabled', false);
				},
				error: function(results) {
					console.log(results);
					$('.form-card-message', form).removeClass('form-card-message-success').addClass('form-card-message-error').text('Uh oh, something went wrong. Try again?');
					$('.button-spinner', form).prop('disabled', false);
				}
			});
		}
	});
	
});